import { LineChart, Line, ResponsiveContainer } from 'recharts';

interface SparklinePoint {
  snapshotDate: string;
  value: number;
}

interface SeasonGrowthSparklineProps {
  points: SparklinePoint[];
  width?: number;
  height?: number;
  ariaLabel?: string;
}

/**
 * Per-row inline sparkline for season-scoped growth. No axes, grid, tooltip,
 * or legend — just a single deep-gold stroke. Keyed by cognitoSub at call
 * sites to ensure the right series renders on every row regardless of sort.
 */
export function SeasonGrowthSparkline({
  points,
  width = 80,
  height = 24,
  ariaLabel,
}: SeasonGrowthSparklineProps) {
  if (!points || points.length === 0) {
    return <div style={{ width, height }} aria-label={ariaLabel} />;
  }
  return (
    <div style={{ width, height }} aria-label={ariaLabel}>
      <ResponsiveContainer width="100%" height="100%">
        <LineChart data={points} margin={{ top: 2, right: 2, bottom: 2, left: 2 }}>
          <Line
            type="monotone"
            dataKey="value"
            stroke="#3d2f0b"
            strokeWidth={1.5}
            dot={false}
            isAnimationActive={false}
          />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
}
